import { render, staticRenderFns } from "./OptionDown.vue?vue&type=template&id=c248ab08"
import script from "./OptionDown.vue?vue&type=script&lang=js"
export * from "./OptionDown.vue?vue&type=script&lang=js"
import style0 from "./OptionDown.vue?vue&type=style&index=0&id=c248ab08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports